/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const CLIENT_PROCEDURE_BEGIN = 'CLIENT_PROCEDURE_BEGIN';
export const CLIENT_PROCEDURE_SUCCESS = 'CLIENT_PROCEDURE_SUCCESS';
export const CLIENT_PROCEDURE_FAILURE = 'CLIENT_PROCEDURE_FAILURE';
export const CLIENT_PROCEDURE_CLEAR = 'CLIENT_PROCEDURE_CLEAR';

export const CLIENT_PROCEDURE_FILTER_BEGIN = 'CLIENT_PROCEDURE_FILTER_BEGIN';
export const CLIENT_PROCEDURE_FILTER_SUCCESS = 'CLIENT_PROCEDURE_FILTER_SUCCESS';
export const CLIENT_PROCEDURE_FILTER_FAILURE = 'CLIENT_PROCEDURE_FILTER_FAILURE';
export const CLIENT_PROCEDURE_FILTER_CLEAR = 'CLIENT_PROCEDURE_FILTER_CLEAR';

export function fetchClientProcedure(params = {}) {
	return async dispatch => {
        dispatch(clientProcedureBegin());
        await ApiService.getClientProcedure(params)
			.then(
            result => {
                dispatch(clientProcedureSuccess(result));
				},
				error => {
                    dispatch(clientProcedureError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchClientProcedureFilter(params = {}) {
    return async dispatch => {
        dispatch(clientProcedureFilterBegin());
        await ApiService.getClientProcedureFilter(params)
            .then(
                result => {
                    dispatch(clientProcedureFilterAdd(result));
                },
                error => {
                    dispatch(clientProcedureFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//ClientProcedure
export const clientProcedureBegin = () => ({
    type: CLIENT_PROCEDURE_BEGIN,
});

export const clientProcedureSuccess = data => ({
    type: CLIENT_PROCEDURE_SUCCESS,
	payload: { data }
})

export const clientProcedureError = () => ({
    type: CLIENT_PROCEDURE_FAILURE,
})

export const clientProcedureClear = () =>({
    type: CLIENT_PROCEDURE_CLEAR,
})

//ClientProcedure Filters
export const clientProcedureFilterBegin = () => ({
    type: CLIENT_PROCEDURE_FILTER_BEGIN,
});
export const clientProcedureFilterAdd = filterData => ({
    type: CLIENT_PROCEDURE_FILTER_SUCCESS,
    payload: { filterData }
})
export const clientProcedureFilterError = filterError => ({
    type: CLIENT_PROCEDURE_FILTER_FAILURE,
    payload: { filterError }
})

export const clientProcedureFilterClear = () => ({
    type: CLIENT_PROCEDURE_FILTER_CLEAR,
})
